exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page-adventure .mdl-card_subtitle{margin:-14px 18px 0;padding:0;font-size:.8em;opacity:.66}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-22742d26!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionAdventureFeed.vue
// module id = 221
// module chunks = 0